export default __webpack_public_path__ + "static/media/EmailVerification.f6820ef7.svg";